export function createValueTypeGuard<T extends string>(values: ReadonlyArray<T>) {
    return function (value: string): value is T {
        return values.includes(value as T)
    }
}
